import gospel from "./gospel.png";

export const Gospeldownloads = () => {
  return (
    <div className="home gallery">
      <img className="canvas img" src={gospel} alt="" />
    </div>
  );
};
